export default class Controller {
    constructor(view, model) {
        // not much else to do here for now
        // more details will come when validation is added
        this.view = view;
        this.model = model;

        this.view.bindDisregardChangeButton(this.reset.bind(this));
    }

    reset() {
        this.model.restoreInitialState();
        const birthday = new Date(this.model.birthday);
        const birthdayString = ('0' + (birthday.getMonth() + 1)).slice(-2) + '-'
            + ('0' + birthday.getDate()).slice(-2) + '-'
            + birthday.getFullYear();
        this.view.resetView(this.model.firstName, this.model.middleName, this.model.lastName, birthdayString, this.model.gender, this.model.ethnicity);
    }
}
